
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/post",
      function () {
        return require("private-next-pages/resources/post.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/post"])
      });
    }
  